__webpack_require__.p = "/bank-app/";